import { styled } from '@mui/material';

// Idle values are styled orange to match how idle is shown elsewhere (the
// IdleStatus "pending — please act" state uses orange.main).
export const StyledOrangeSpan = styled('span')(({ theme }) => ({
  color: theme.palette.orange.main,
}));
